import { Component, OnInit, Input, Pipe, PipeTransform } from '@angular/core';


@Component({
  selector: 'app-card-vendedor',
  templateUrl: './card-vendedor.component.html',
  styleUrls: ['./card-vendedor.component.css']
})
export class CardVendedorComponent implements OnInit {

  spinFast: Boolean = false;
  mcActive: Boolean = false;
  arrowLeft: Boolean = false;
  bars: Boolean = true;

  @Input() titulo: string;
  @Input() descricao: string;

  constructor() { }

  ngOnInit() {
  }

  btnActionClick(){
    this.spinFast = true;

    if (this.mcActive){
      this.mcActive = false;
      setTimeout(() => {
        this.arrowLeft = false;
        this.spinFast = false;
        this.bars = true;
      }, 600);
    } else {
      this.mcActive = true;
      setTimeout(() => {
        this.spinFast = false;
        this.bars = false;
        this.arrowLeft = true;
      }, 600);

    }
  }

  isSpinFast(){
    return this.spinFast;
  }

  isMcActive(){
    return this.mcActive;
  }

  isArrowLeft(){
    return this.arrowLeft;
  }

  isBars(){
    return this.bars;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/card-vendedor/card-vendedor.component.ts